import { render, staticRenderFns } from "./HeartysanManufacturerChatsTable.vue?vue&type=template&id=8c9103c6&scoped=true"
import script from "./HeartysanManufacturerChatsTable.vue?vue&type=script&lang=js"
export * from "./HeartysanManufacturerChatsTable.vue?vue&type=script&lang=js"
import style0 from "./HeartysanManufacturerChatsTable.vue?vue&type=style&index=0&id=8c9103c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9103c6",
  null
  
)

export default component.exports